import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import {RmModalSaveComponent} from '../components/rm-modal-save/rm-modal-save.component';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class RmGuardDraftGuard extends RmModalSaveComponent implements CanDeactivate<CanComponentDeactivate> {

    canDeactivate() {
        if (this.preventDestroy) {
            return true;
        }

        if (this.draftService.isPersistableOrder(this.order, this.ratesMobile)) {
            const options: NgbModalOptions = {
                backdrop: 'static',
                size: 'lg',
                centered: true,
                windowClass: 'modalAlertChange'
            };

            this.modalService.open(RmModalSaveComponent, options);
            return this.draftService.continueNavigation;
        }

        return true;
    }
}
